import { DARK } from './types';

export default {
  title: DARK,
  colors: {
    charts: {
      backgroundChartColor: '#202529',
      title: '#00BEC1',
      label: {
        text: '#FFFFFF',
        line: '#FFFFFF',
      },
      legend: {
        color: '#FFFFFF',
        pagination: {
          buttons: {
            color: '#FFFFFF',
          },
          text: {
            color: '#FFFFFF',
          },
        },
      },
      cardThemes: {
        neutral: [
          '#12004A', '#18106A', '#1F208A', '#2531AA', '#2C41CA', 
          '#3251EA', '#3161EC', '#3071EE', '#2E80F0', '#2D90F2', 
          '#2CA0F4', '#52B1F6', '#78C2F8', '#9ED4FA'
        ],
      },
      colors: [
        '#5A6FC0', '#9ECA7F', '#F2CA6B', '#DE6E6A', '#85BEDB',
        '#59A076', '#EC8A5D', '#9263AF', '#DC82C8', '#47599C',
        '#6F9D4E', '#D0A132', '#FF9896', '#3D83A6', '#3D7F58',
        '#AD5F3C', '#6D4586', '#BD60A9', '#354A78', '#617F4D',
        '#AD7B02', '#AA6976', '#196084', '#2E6243', '#8E4625',
        '#53256F', '#9A4086'],
      axis: {
        x: {
          label: '#FFFFFF',
          line: '#FFFFFF',
        },
        y: {
          label: '#FFFFFF',
          line: '#FFFFFF',
        },
      },
      radar: {
        radiusAxis: {
          label: '#FFFFFF',
          line: '#FFFFFF',
          splitLine: '#32383D',
        },
      },
      correlation: {
        zoom: {
          buttons: '#00BEC1',
          disabled: '#A1B4C4',
          divider: '#32383D',
        },
      },
      simulation: {
        gradientTargetColor: 'rgba(0, 0, 0, 0)',
      },
      highlitedItemBorderType: 'dashed',
      highlitedItemBorderColor: '#FFF',
      highlitedItemBorderWidth: 2,
    },
    primary: '#32383D',
    secondary: '#00BEC1',
    highLight: '#18191B',
    statusError: '#EB5757',
    lightGray: '#313940',
    constrat: '#FFFFFF',
    brand: '#610082',
    component: '#202529',
    details: '#4C555C',
    text: {
      default: '#FFFFFF',
      placeholder: '#A1B4C4',
    },
    diviserColor: '#42484D',
    diviserSmoothColor: '#4C555C',
    backgroundColorPage: '#32383D',
    backgroundColorcomponent: '#202529',
    titleButtonSeletorHead: '#00BEC1',
    cartTitleColor: '#00BEC1',
    cardTypeColor: '#00BEC1',
    inputSearchColor: '#4C555C',
    groupInputsColor: '#32383D',
    groupInputsSeletorWrapperColor: '#4C555C',
    cardSeletorHeadColor: '#4C555C',
    actionButtonsColor: '#FFFFFF',
    avataBackgroundColor: '#18191B',
    avataTextColor: '#FFFFFF',
    avataTextColorExit: '#A1B4C4',
    avataBorderColor: '#00BEC1',
    avataShadowColor: 'rgba(0, 0, 0, 0.25);',
    avataDiviserColor: 'rgba(255, 255, 255, 0.1)',
    cardSettingsTitleColor: '#00BEC1',
    cardSettingsTextColor: '#FFFFFF',
    cardSettingsBackgroundcolor: '#32383D',
    cardSettingsSeletorBodyBorderColor: '#00BEC1',
    cardSettingsSeletorBackgroundColor: '#4C555C',
    exportingPopupBackBtnColor: '#00BEC1',
    exportingPopupBtnDisabled: '#202529',
    exportingPopupOkBtn: '#00BEC1',
    exportingPopupTitleColor: '#00BEC1',
    exportingPopupTextColor: '#FFFFFF',
    exportingPopupBackgroundcolor: '#32383D',
    exportingPopupSeletorBodyBorderColor: '#00BEC1',
    exportingPopupSeletorBackgroundColor: '#4C555C',
    previewComponentLabelColor: '#FFFFFF',
    previewComponentInputColor: '#00BEC1',
    previewComponentBackgroundColor: '#202529',
    previewComponentHeaderBackgroundColor: '#18191B',
    previewComponentDivisorColor: '#6C6C6C',
    seletorSimpleSeletorBodyColor: '#4C555C',
    seletorSearchBackgroundcolor: '#4C555C',
    seletorBodyBorderColor: '#4C555C',
    chartEmptyColor: '#4C555C',
    chartEmptyTopRowColor: '#4C555C',
    chartEmptyHeaderTextColor: '#FFF',
    chartEmptyHelperTextColor: '#C9C9C9',
    chartEmptyTextRowColor: '#00BEC1',
    UploadSurveyTitleColor: '#FFFFFF',
    UploadSurveyInputColor: '#32383D',
    UploadSurveyOptionsBorderColor: 'rgb(255, 255, 255, .2)',
    UploadSurveyBackgroundActiveItem: '#4C555C',
    modalTitleColor: '#FFFFFF',
    headerConfigLine: '#a1b4c433',
    modalBackgroundColor: '#32383D',
    modalInputSearchBackgroundColor: '#4C555C',
    modalTitleBorderColor: 'rgba(76, 85, 92, 1)',
    ModalTabActiveColor: '#00BEC1',
    ModalTabInativeColor: '#A1B4C4',
    ModalTabInativeBottomColor: '#A1B4C4',
    ArrowIconCheckColor: '#00BEC1',
    ArrowIconUncheckColor: '#00BEC1',
    ItemCheckedColor: '#00BEC1',
    buttonHoverBackgroundColor: '#42484D',
    numbersMenuTextColor: '#00BEC1',
    numbersMenuBackgroundColor: '#18191B',
    radioButtonColor: '#00BEC1',
    normalButtonHoverBackgroundColor: '#023A3B',
    normalButtonBackgroundColor: '#035354',
    normalConsolidationButtonBackgroundColor: '#202529',
    normalConsolidateButtonBackgroundColor: '#00BEC1',
    normalConsolidationTextLabelColor: '#00BEC1',
    normalConsolidationIconColor: '#ffffff',
    normalButtonTextColor: '#ffffff',
    normalButtonHoverTextColor: '#ffffff',
    clearButtonHoverBackgroundColor: '#444a4f',
    clearButtonBackgroundColor: 'transparent',
    clearButtonTextColor: '#ffffff',
    clearButtonHoverTextColor: '#00BEC1',
    promptBackgroundColor: 'rgba(0, 0, 0, 0.6)',
    promptPanelBackgroundColor: '#32383D',
    promptTextColor: '#FFFFFF',
    promptOkButtonColor: '#00C6C9',
    EvolutivevOkButtonColor: '#023A3B',
    surveysManagerTextColor: '#FFFFFF',
    surveysManagerRightBorderColor: '#E6E6E7',
    editorModalTextColor: '#FFFFFF',
    activeMenuBackgroundColor: '#18191B',
    searchIconColor: '#00C6C9',
    headerGroupInputsBackgroundColor: '#32383D',
    headerGroupInputsColorWhenSelected: '#00BEC1',
    borderErrorColor: 'red',
    errorMessageTextColor: '#FFFFFF',
    configSelectorDarkInputTextColor: '#32383D',
    backgroundColorHeader: '#18191B',
    headerName: '#FFF',
    iconButtonColor: '#00BEC1',
    surveysManagerTableBorderColor: '#A1B4C4',
    surveysManagerIconColor: '#FFF',
    menuItem: '#202529',
    menuItemTextColor: '#FFFFFF',
    selectorTitle: '#FFF',
    selectorBodyCloser: '#FFF',
    backgroundColorPageInput: '#32383D',
    colorPageInputLabel: '#C4C4C4',
    nextPageInputBorder: '#00BEC1',
    highlightFocusItem: 'linear-gradient(180deg, #EBEBEB 0%, #4C555C 0.01%, #758089 100%);',
    disabledMenuItem: '#4C555C',
    disabledMeatballItem: '#555F66',
    warningMessage: '#CA8B41',
    tooltipBackgroundColor: '#610082',
    newTooltipBackgroundColor: '#D9D9D9',
    newTooltipTextColor: '#000',
    tooltipTextColor: '#FFF',
    tooltipBorderColor: '#610082',
    menuIconTextColor: '#FFFFFF',
    menuMobileIconTextColor: '#FFFFFF',
    editSurveyBackgroundColor: '#4C555C',
    calendarMonthFontColor: '#FFFFFF',
    calendarBetaMonthFontColor: '#4C555C',
    calendarDaysMonthFontColor: '#A1B4C4',
    calendarHeaderBackgroundColor: '#18191B',
    calendarBodyBackgroundColor: '#202529',
    calendarSelectedDay: '#00BEC1',
    consolidationComebackWrapper: '#555F66',
    titleEvolutiveCross: '#FFFFFF',
    labelEvolutiveCross: '#1E2123',
    disableEvolutiveButton: '#3C4449',
    disableEvolutiveTextBtn: '#A3B1BB',
    iconEvolutiveColor: '#99ABBA',
    dateFilterBackgroundColor: '#1E2123',
    cardContainerEvolutiveCross: '#555F66',
    labelFontColorEvolutiveCross: '#00bec1',
    borderButtonEvolutiveCross: '#a1b4c4',
    headerCrossListContainer: '#32383D',
    backgroundItemColor: '#035354',
    titleItemColor: '#F5F6FA',
    borderColorCollapsibleContainer: '#00bec1',
    borderHoverCollapsibleContainer: '#FFF',
    disableConsolidateBtn: '#4c555c66',
  },
  simpleCross: {
    tableHeadBackgroud: '#00BEC1',
    tableHeadColor: '#18191B',
    crossQuestionColor: '#fff',
    crossQuestionBackground: '#4C555C',
    borderColor: '#4C555C',
    borderBottomColor: 'rgba(0, 0, 0, 0.6)',
    resultCelBackground: '#202529',
    gradeTitleBackground: '#035354',
    resultCelColor: '#fff',
    footerResultCelFontWeight: 'normal',
    footerTotalCelFontWeight: 'bold',
  },
  collapsibleList: {
    itemHoverBackground: '#610082',
    textColor: '#A1B4C4',
    titleColorBolded: '#00BEC1',
    titleColorUnBolded: '#A1B4C4',
    circleBorder: '#00bec1',
  },
  collapsibleOrderableList: {
    itemHoverBackground: '#610082',
    itemHoverColor: '#fff',
    textTitle: '#fff',
  },
  evolutiveConfig: {
    labelColor: '#fff',
  },
  simpleCrossConfig: {
    labelTextColor: '#fff',
  },
  cardSettings: {
    color: '#fff',
  },
  card: {
    titleComplementHoverBackgroud: '#4C555C',
    listItemsTextColor: '#F5F6FA',
  },
  uploadSurvey: {
    uploadTipColor: '#FFFFFF',
  },
  simulation: {
    sliderThumbBorderColor: '#00BEC1',
    sliderThumbBackgroundColor: '#A1B4C4',
    sliderActiveBackgroundColor: '#00BEC1',
    sliderGroupBackgroundColor: '#32383D',
    sliderGroupBorder: '#00BEC1',
    infoBackgroundColor: '#00BEC1',
    staticTextColor: '#A1B4C4',
    dynamicTextColor: '#A1B4C4',
    iconColor: '#00BEC1',
    labelTextColor: '#FFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  cardAnnotationsMenu: {
    textColor: '#FFFFFF',
    iconColor: '#FFFFFF',
    iconDownColor: '#00BEC1 ',
  },
  cardAnnotations: {
    iconColor: '#fff',
  },
  cardExporting: {
    iconColor: '#FFF',
  },
  richTextToolbar: {
    iconColor: '#A1B4C4',
  },
  richTextBox: {
    editor: {
      background: '#4C555C',
      color: '#ccc',
      placeHolder: '#A1B4C4',
    },
  },
  surveyManagement: {
    bodyIcon: {
      color: '#00BEC1',
    },
  },
};
